<template>
    <v-card>
        <v-card-text
            :class="parentTextClass"
        >
            <legacy-title
                class="mt-3 mb-8 title-branding"
            >
                {{ title }}
            </legacy-title>
            <v-form
                ref="form"
                lazy-validation
                v-model="formIsValid"
            >
                <slot name="form"></slot>
            </v-form>
            <v-divider class="mt-3"></v-divider>
        </v-card-text>
        <slot name="actions"></slot>
    </v-card>
</template>

<script>
    import LegacyTitle from './Title';

    export default {
        name: "Form",

        components: {
            LegacyTitle
        },

        props: {
            'title': {
                type: String,
                default: ''
            },
            'parentTextClass': {
                type: String,
                default: '',
            }
        },

        data() {
            return {}
        },

        methods: {
            validateForm() {
                return new Promise((resolve, reject) => {
                    this.$refs.form.validate();
                    resolve();
                });
            }
        }
    }
</script>
